// src/components/Page.jsx
import React from "react";
import OrganizationSelector from "components/OrganizationSelector";

export default function Page({
  title,
  subtitle,
  right = null,
  showOrganizationSelector = false,
  onSelectOrganization,
  ribbon = null,
  children,
  titleAsCard = true,
  className = "",
}) {
  return (
    <div className={`flex flex-col min-h-full p-4 pb-12 ${className}`}> {/* p-# horizontal space on side of each card */}
      {/* Header */}
      <div
        className={`mb-4 ${ /* controls space below header card */
          titleAsCard
            ? [
                "rounded-[var(--radius)] border border-app shadow-sm",
                "bg-[hsl(var(--background))] text-app",
                "px-4 py-2",
              ].join(" ")
            : ""
        }`}
      >
        {/* Title + optional right-side controls */}
        <div className="flex items-start justify-between gap-4">
          <div>
            <h1 className="text-xl font-semibold text-brand">{title}</h1>
            {subtitle && (
              <div className="text-sm text-muted mt-0.5">{subtitle}</div>
            )}
          </div>
          <div className="flex flex-wrap items-end justify-end gap-3">
            {right}
            {showOrganizationSelector ? (
              <OrganizationSelector onSelectOrganization={onSelectOrganization} />
            ) : null}
          </div>
        </div>

        {/* Ribbon section (below title, same card) */}
        {ribbon && <div className="mt-2">{ribbon}</div>}
      </div>

      {/* Content - space-y-# controls space between section cards */}
      <div className="space-y-4 flex-1">{children}</div> 
    </div>
  );
}
